import withMatcher from '#/utils/withMatcher';
import { TStatePlayer } from '../reducers/player';

export const createActionPlayerSetPlayer = withMatcher(
  (payload: Spotify.Player) => {
    return {
      type: 'player/set_player',
      payload,
    };
  }
);

export const createActionPlayerSetIsPaused = withMatcher((payload: boolean) => {
  return {
    type: 'player/set_paused',
    payload,
  };
});

export const createActionPlayerSetIsActive = withMatcher((payload: boolean) => {
  return {
    type: 'player/set_active',
    payload,
  };
});

export const createActionPlayerSetCurrentTrack = withMatcher(
  (payload: TStatePlayer['currentTrack']) => {
    return {
      type: 'player/set_current_track',
      payload,
    };
  }
);

export const createActionPlayerSetPosition = withMatcher((payload: number) => {
  return {
    type: 'player/set_position',
    payload,
  };
});

export const createActionPlayerSetRepeat = withMatcher((payload: boolean) => {
  return {
    type: 'player/set_repeat',
    payload,
  };
});

export const createActionPlayerSetShuffle = withMatcher((payload: boolean) => {
  return {
    type: 'player/set_shuffle',
    payload,
  };
});

export const createActionPlayerSetCurrentIsFavorite = withMatcher(
  (payload: boolean) => {
    return {
      type: 'player/set_current_is_favorite',
      payload,
    };
  }
);

export const createActionPlayerSetVolume = withMatcher((payload: number) => {
  return {
    type: 'player/set_volume',
    payload,
  };
});
